import React, { useEffect, useContext, useState } from 'react';

const WatchlistNotificationShowContext = React.createContext();
const WatchlistNotificationStateContext = React.createContext();

const TOAST_TIMEOUT = 3000;

function WatchlistNotificationProvider({ children }) {
    const [state, toggleShowNotification] = useState({
        display: false,
        pushClass: children.props.pushWatchlistNotification
    });
    useEffect(
        () => {
            if (state.display) {
                const timer = setTimeout(() => {
                    toggleShowNotification({
                        display: false
                    });
                }, TOAST_TIMEOUT);

                return () => clearTimeout(timer);
            }
            return () => {};
        },
        [state]
    );
    return (
        <WatchlistNotificationStateContext.Provider value={state}>
            <WatchlistNotificationShowContext.Provider
                value={toggleShowNotification}
            >
                {children}
            </WatchlistNotificationShowContext.Provider>
        </WatchlistNotificationStateContext.Provider>
    );
}

function useWatchlistNotificationState() {
    const context = useContext(WatchlistNotificationStateContext);
    if (context === undefined) {
        throw new Error(
            'useWatchlistNotificationState must be used within a WatchlistNotificationProvider'
        );
    }
    return context;
}

function useWatchlistNotificationTrigger() {
    const context = useContext(WatchlistNotificationShowContext);
    if (context === undefined) {
        throw new Error(
            'useWatchlistNotificationTrigger must be used within a WatchlistNotificationProvider'
        );
    }

    return context;
}

export {
    WatchlistNotificationProvider,
    useWatchlistNotificationState,
    useWatchlistNotificationTrigger
};
